import api from '../api'

export default {

  catalogueItems: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/catalogue-items?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },



  createGetData: async ()=> {
    return api.get('api/catalogue-items/create')
  },

  create: async item => {
    return api.post('api/catalogue-items', item)
  },

  get: async id => {
    return api.get('api/catalogue-items/' + id)
  },

  update: async (id,item) => {
    return api.put('api/catalogue-items/' + id, item)
  },

  delete: async id => {
    return api.delete('api/catalogue-items/' + id)
  },

  image: async (item,image) => {
    return api.post(`api/catalogue-items/${item.id}/image`,image)
  },

  imageDelete: async (item,image) => {
    return api.delete(`api/catalogue-items/${item.id}/image/${image.id}`)
  },

  imageUpdate: async (item,image) => {
    return api.put(`api/catalogue-items/${item.id}/image/${image.id}`,image)
  },

  //Share

  catalogueItemsShareList: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/catalogue-items-share/list?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  catalogueItemsSharePdf: async (itemIds) => {
    return api.get(`api/catalogue-items-share/pdf?items=${itemIds}`,{
        headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType : 'blob'
      })
  },
}
